import { useEffect } from 'react';

/**
 * Sets document.title and the meta description for a route.
 * CRA has no SSR head management; this keeps titles correct for
 * bookmarks, history, and client-side navigation.
 */
export function usePageMeta(title: string, description?: string): void {
  useEffect(() => {
    document.title = title;
    if (description) {
      const tag = document.querySelector('meta[name="description"]');
      if (tag) tag.setAttribute('content', description);
    }
  }, [title, description]);
}
